<template>
  <Main>
    <template v-slot:toolbar>
      <div class="white">
        <StepToolbar
          class="max-content-width"
          :steps="toolbarSteps"
          :current-step="currentStep"
        />
      </div>
    </template>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        :items="breadcrumbAccordingStep"
        @return="previousStep"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb :items="breadcrumbAccordingStep" @return="previousStep" />
    </template>
    <InsuranceStepForm
      v-if="currentStep.name == steps.form"
      @updateStep="changeStep"
      :form="formAccordingStep"
      @relationshipContact="stepRelationshipContact"
    />
    <InsuranceStepModality
      v-if="currentStep.name == steps.modality"
      @updateStep="changeStep"
      :form="formAccordingStep"
      :return="returnStep"
      :insurance="getForm(steps.form)"
      @submit="submit"
      @editModality="editModality"
    />
    <ListModality
      v-if="currentStep.name == steps.selectModality"
      @updateStep="changeStep"
      :return="returnStep"
      :insurance="getForm(steps.form)"
      :form="getModality()"
      :modality="getForm(steps.modality)"
      @newModality="newModality"
    />
    <NewRelationshipContact
      v-if="currentStep.name == steps.newContact"
      @updateStep="changeStep"
      @updateContact="saveRelationshipContact"
      :return="returnStep"
      :form="formAccordingStep"
      :insurance="getForm(steps.form)"
      @setReturnFalse="setReturnFalse"
    />
    <EditModalityChosen
      v-if="currentStep.name == steps.editModality"
      @updateStep="changeStep"
      :return="returnStep"
      :modality="getForm(steps.selectModality)"
      :insurance="getForm(steps.form)"
      :form="formAccordingStep"
      @updateModality="saveModality"
      @edit="editSubModality"
      @new="newSubModality"
      @setReturnFalse="setReturnFalse"
    />
    <ListSubModality
      v-if="currentStep.name == steps.selectSubModality"
      @updateStep="changeStep"
      :return="returnStep"
      :modality="getForm(steps.selectModality)"
      :insurance="getForm(steps.form)"
      :form="formAccordingStep"
      :sub-modality="getForm(steps.editModality)"
    />
    <EditSubModalityChosen
      v-if="currentStep.name == steps.editSubModality"
      @updateStep="changeStep"
      :return="returnStep"
      :insurance="getForm(steps.form)"
      :sub-modality="getForm(steps.selectSubModality)"
      :form="formAccordingStep"
      @updateSubModality="saveSubModality"
      @setReturnFalse="setReturnFalse"
    />
    <ModalCancelInsurance @close="closeModal" v-model="modalCancel" />
    <ModalGenerateInsuranceCompany
      v-model="modalSubmit"
      @close="closeModalSubmit"
    />
  </Main>
</template>
<script>
import InsuranceStepForm from "../new_insurance_steps/InsuranceStepForm";
import InsuranceStepModality from "../new_insurance_steps/InsuranceStepModality";
import ListModality from "../new_insurance_steps/ListModality";
import NewRelationshipContact from "../new_insurance_steps/NewRelationshipContact";
import ModalCancelInsurance from "../components/ModalCancelInsurance";
import EditModalityChosen from "../new_insurance_steps/EditModalityChosen";
import ListSubModality from "../new_insurance_steps/ListSubModality";
import EditSubModalityChosen from "../new_insurance_steps/EditSubModalityChosen";
import ModalGenerateInsuranceCompany from "../components/ModalGenerateInsuranceCompany";
import { mapActions } from "vuex";
import _ from "lodash";
import { InsuranceCompanyMixin } from "@/mixins/NewInsuranceCompanyMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
const toolbarSteps = [
  {
    name: "1. Seguradora",
    step: 1
  },
  {
    name: "2. Adicionar Modalidade",
    step: 2
  }
];
const tabSteps = {
  form: "insurance_company step form",
  modality: "insurance_company step modality",
  selectModality: "insurance_company select modality",
  newContact: "insurance_company new contact",
  editModality: "insurance_company edit modality",
  selectSubModality: "insurance_company select sub modality",
  editSubModality: "insurance_company edit sub modality"
};
const itemSteps = [
  {
    form: {
      logo: null,
      ativo: true,
      nome: null,
      cnpj: null,
      razao_social: null,
      nome_fantasia: null,
      registro_susep: null,
      categoria: null,
      endereco: {
        cep: null,
        logradouro: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        uf: null
      },
      contatos_linha_credito: [],
      contatos_relacionamento: []
    },
    step: tabSteps.form,
    breadcrumb: [
      {
        to: "insurance_company",
        text: "Adicionar Seguradora"
      }
    ]
  },
  {
    form: {
      aceita_link_arquivos: false,
      tamanho_maximo_arquivos_mb: 0,
      modalidades: []
    },
    step: tabSteps.modality,
    breadcrumb: [
      {
        to: "insurance_company step form",
        text: "Adicionar Seguradora"
      }
    ]
  },
  {
    form: {},
    step: tabSteps.selectModality,
    breadcrumb: [
      {
        to: "insurance_company step modality",
        text: "Adicionar Seguradora"
      }
    ]
  },
  {
    form: {
      ativo: true,
      nome: null,
      email: null,
      telefone1: null,
      telefone2: null,
      departamento: null
    },
    step: tabSteps.newContact,
    breadcrumb: [
      {
        to: "insurance_company step form",
        text: "Adicionar Contatos Relacionamento"
      }
    ]
  },
  {
    form: {},
    step: tabSteps.editModality,
    breadcrumb: [
      {
        to: "insurance_company step modality",
        text: "Adicionar Seguradora"
      }
    ]
  },
  {
    form: {},
    step: tabSteps.selectSubModality,
    breadcrumb: [
      {
        to: "insurance_company edit modality",
        text: "Adicionar Seguradora"
      }
    ]
  },
  {
    form: {},
    step: tabSteps.editSubModality,
    breadcrumb: [
      {
        to: "insurance_company select sub modality",
        text: "Adicionar Seguradora"
      }
    ]
  }
];
const firstStep = {
  name: "insurance_company step form",
  step: 1
};
export default {
  beforeRouteLeave(to, from, next) {
    if (this.cancel || this.formIsPristine()) next();
    this.modalCancel = true;
    this.nextRoute = to;
  },
  data: () => ({
    toolbarSteps,
    currentStep: firstStep,
    steps: tabSteps,
    itemSteps: {},
    cancel: false,
    modalCancel: false,
    returnStep: false,
    isEditModality: false,
    positionSubModality: null,
    modalSubmit: false
  }),
  components: {
    InsuranceStepForm,
    InsuranceStepModality,
    ModalCancelInsurance,
    NewRelationshipContact,
    ListModality,
    EditModalityChosen,
    ListSubModality,
    EditSubModalityChosen,
    ModalGenerateInsuranceCompany
  },
  mixins: [LoadingRequest, InsuranceCompanyMixin],
  computed: {
    formAccordingStep() {
      return this.itemSteps.find(x => x.step == this.currentStep.name).form;
    },
    breadcrumbAccordingStep() {
      return this.itemSteps.find(x => x.step == this.currentStep.name)
        .breadcrumb;
    },
    hasToolbarStep() {
      return (
        this.currentStep.name == this.steps.form ||
        this.currentStep.name == this.steps.modality
      );
    }
  },
  created() {
    // pegar uma cópia em vez de uma referência, para
    // quando for cancelada e depois ela iniciar uma nova,
    // ela esteja resetada
    this.itemSteps = _.cloneDeep(itemSteps);
  },
  methods: {
    ...mapActions("insuranceCompany", [
      "requestNewInsuranceCompany",
      "requestUploadLogo"
    ]),
    ...mapActions(["showAlertNotification"]),
    formIsPristine() {
      return (
        _.isEqual(this.itemSteps[1].form, itemSteps[1].form) &&
        _.isEqual(this.itemSteps[0].form, itemSteps[0].form)
      );
    },
    stepRelationshipContact(payload) {
      this.returnStep = false;
      // Atualiza o formulário do passo atual
      this.itemSteps.find(x => x.step == this.currentStep.name).form =
        payload.form;
      // Atualiza o formulário do contatos de relacionamento
      // para saber se estou editando o contato
      // ou criando um novo contato
      this.itemSteps.find(x => x.step == this.steps.newContact).form =
        payload.item;
      this.currentStep = payload.step;
    },
    changeStep(payload) {
      this.returnStep = false;
      this.isEditModality = false;
      this.itemSteps.find(x => x.step == this.currentStep.name).form =
        payload.form;
      this.currentStep = payload.step;
    },
    saveModality(payload) {
      // Reseta o formulário de editar modalidade
      this.itemSteps.find(x => x.step == this.steps.editModality).form = {};
      // Buscar o formulário que tenha a lista
      // das modalidades
      let form = this.itemSteps.find(x => x.step == this.steps.modality).form
        .modalidades;
      const index = form.indexOf(payload.form);
      // verifica se ele já existe na lista ou não
      if (index == -1) {
        form.push(payload.form);
      } else {
        form[index] = payload.form;
      }
      this.returnStep = false;
      this.currentStep = payload.step;
    },
    closeModal(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({ name: this.nextRoute.name });
      }
    },
    previousStep(to) {
      // Como o breadcrumb precisa ficar no pai por conta
      // de ser um template slot, preciso mandar para o filho
      // a informação que ele deseja voltar para o passo
      // anterior, para o filho poder enviar o formulário
      // para o pai, antes de mudar de componente
      if (to == "insurance_company") {
        this.$router.push({ name: to });
      } else {
        this.returnStep = true;
      }
    },
    getForm(step) {
      return this.itemSteps.find(x => x.step == step).form;
    },
    async submit(form) {
      // TODO: fazer integração
      this.itemSteps.find(x => x.step == this.steps.modality).form = form;
      // Se tiver logo, preciso dar upload na logo
      // e adicionar a url antes de criar nova seguradora
      if (this.itemSteps[0].form.logo)
        this.itemSteps[0].form.logo = await this.withLoading(
          this.requestUploadLogo(
            this.getUploadFilePayload(this.itemSteps[0].form.logo)
          )
        );
      await this.withLoading(
        this.requestNewInsuranceCompany(this.getPayload(this.itemSteps)).then(
          () => {
            this.modalSubmit = true;
          }
        )
      );
    },
    newModality(payload) {
      this.itemSteps.find(x => x.step == this.steps.editModality).form = {
        ativo: true
      };
      this.changeStep(payload);
    },
    editModality(payload) {
      // Atualiza o form da lista de modalidades
      // para mostrar a modalidade escolhida
      // que será editada
      this.itemSteps.find(x => x.step == this.steps.selectModality).form =
        payload.item.modalidade;
      this.itemSteps.find(x => x.step == this.steps.editModality).form =
        payload.item;
      this.changeStep(payload);
      this.isEditModality = true;
    },
    getModality() {
      return this.isEditModality ? this.getForm(this.steps.selectModality) : {};
    },
    editSubModality(payload, position) {
      this.itemSteps.find(x => x.step == this.steps.selectSubModality).form =
        payload.item.submodalidade;
      this.itemSteps.find(x => x.step == this.steps.editSubModality).form =
        payload.item;
      this.positionSubModality = position;
      this.changeStep(payload);
    },
    newSubModality(payload) {
      this.changeStep(payload);
      this.itemSteps.find(
        x => x.step == this.steps.selectSubModality
      ).form = {};
      this.itemSteps.find(x => x.step == this.steps.editSubModality).form = {
        ativo: true
      };
      this.positionSubModality = null;
      this.changeStep(payload);
    },
    saveSubModality(payload) {
      // Reseta o formulário de editar sub modalidade
      this.itemSteps.find(x => x.step == this.steps.editSubModality).form = {};
      this.itemSteps.find(
        x => x.step == this.steps.selectSubModality
      ).form = {};
      // Buscar o formulário que tenha a lista
      // das modalidades
      let form = this.itemSteps.find(x => x.step == this.steps.editModality)
        .form.submodalidades;
      // verifica se ele já existe na lista ou não
      if (this.positionSubModality == null) {
        form.push(payload.form);
      } else {
        form[this.positionSubModality] = payload.form;
      }
      this.returnStep = false;
      this.currentStep = payload.step;
      this.positionSubModality = null;
    },
    closeModalSubmit(newInsurance) {
      this.modalSubmit = false;
      if (newInsurance) {
        // O usuário não deseja adicionar nova seguradora
        // portanto devo resetar os passos e os fomulários
        this.itemSteps = _.cloneDeep(itemSteps);
        this.currentStep = firstStep;
      } else {
        // O usuário não deseja adicionar nova seguradora
        this.cancel = true;
        this.$router.push({ name: "insurance_company" });
      }
    },
    setReturnFalse() {
      this.returnStep = false;
    }
  }
};
</script>
